import React, { FC } from 'react';
import  { useEffect } from 'react';

import {
    Box,
    Typography,
    Container,
    Button
   
 
} from '@mui/material';
import { motion } from 'framer-motion';

const Disclaimer: FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top of the page when this component is mounted
      }, []);

  return (
      <Box>
        <Box
                    component="section"
                    sx={{
                        backgroundColor: '#0F1521',
                        color: 'common.white',
                        position: 'relative',
                        overflow: 'hidden',
                        py: { xs: 6, md: 10 },
                        minHeight: { xs: 'auto', md: '80vh' },
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    {/* Animated gradient background */}
                    <Box
                        sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            opacity: 0.1,
                            background: 'radial-gradient(circle at 50% 50%, #FF6B00 0%, transparent 50%)',
                            animation: 'pulse 8s ease-in-out infinite',
                            '@keyframes pulse': {
                                '0%': { transform: 'scale(1)' },
                                '50%': { transform: 'scale(1.5)' },
                                '100%': { transform: 'scale(1)' }
                            }
                        }}
                    />
                    <motion.div
                        initial={{ width: 0 }}
                        animate={{ width: '100px' }}
                        transition={{ duration: 1, delay: 0.5 }}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: '20%',
                                left: '20%',
                                height: '2px',
                                backgroundColor: '#FF6B00',
                                opacity: 0.3,
                                zIndex: 0
                            }}
                        />
                    </motion.div>
        
                    {/* Globe image with parallax effect */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 0.8, scale: 1 }}
                        transition={{ duration: 1.5 }}
                        style={{
                            position: 'absolute',
                            bottom: '-15%',
                            right: '0%',
                            width: '70%',
                            maxWidth: '1000px',
                            zIndex: 0,
                        }}
                    >
                        <Box
                            component="img"
                            src="/globe.avif"
                            alt="Globe"
                            sx={{
                                width: '100%',
                                height: 'auto',
                                filter: 'hue-rotate(30deg) saturate(0.8)',
                                animation: 'float 6s ease-in-out infinite',
                                '@keyframes float': {
                                    '0%, 100%': { transform: 'translateY(0px)' },
                                    '50%': { transform: 'translateY(-20px)' }
                                }
                            }}
                        />
                    </motion.div>
        
                    <Container
                        maxWidth="lg"
                        sx={{
                            position: 'relative',
                            zIndex: 2,
                            mt: { xs: 0, md: -10 }
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                maxWidth: '700px',
                                mx: 'auto',
                                textAlign: 'center'
                            }}
                        >
                            <motion.div
                                initial={{ opacity: 0, y: -20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8 }}
                            >
                                <Typography
                                    variant="h2"
                                    sx={{
                                        color: 'common.white',
                                        fontWeight: 700,
                                        mb: { xs: 3, md: 4 },
                                        fontSize: { xs: '2.5rem', sm: '3rem', md: '4.25rem' },
                                        lineHeight: 2.3,
                                        textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                    }}
                                >
                               
                                    <Typography
                                        component="span"
                                        variant="inherit"
                                        sx={{
                                            background: 'linear-gradient(90deg, #FF6B00 0%, #FF9D00 100%)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            fontWeight: 700
                                        }}
                                    >
                                     Disclaimer
                                    </Typography>
                                </Typography>
                            </motion.div>
        
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8, delay: 0.3 }}
                            >
                            </motion.div>
        
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8, delay: 0.6 }}
                                whileHover={{ scale: 1.05 }}
                            >
                                <Button
                                    component="a"
                                    href="https://cal.com/support-team-qsszsx"
                                    target="_blank"
                                    variant="contained"
                                    size="large"
                                    sx={{
                                        py: 1.25,
                                        px: 4,
                                        borderRadius: 2,
                                        fontSize: '0.9rem',
                                        fontWeight: 600,
                                        backgroundImage: 'linear-gradient(to right, #360033 0%, #0b8793 51%, #360033 100%)',
                                        backgroundSize: '200% auto',
                                        color: 'white',
                                        boxShadow: '0 0 20px #eee',
                                        textTransform: 'uppercase',
                                        transition: '0.5s',
                                        padding: '15px 35px',
                                        height: '46px',
                                        width: 'fit-content',
                                        margin: '10px',
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        marginBottom: '20px',
                                        gap: '5px',
                                        '&:hover': {
                                            backgroundPosition: 'right center',
                                            color: '#fff',
                                            textDecoration: 'none',
                                        },
                                    }}
                                >
                                    Talk to us
                                </Button>
                            </motion.div>
                        </Box>
                    </Container>
        
        
        </Box>
        <Box 
        sx={{
            backgroundColor: 'white',
            color: 'black',
            display: 'flex',
            flexDirection: 'column',
            px: {
              xs: 2.5,  // 20px (1 spacing unit = 8px)
              md: 3.75, // 30px
              lg: 8.25  // 50px
            },
            py: {
                xs: 2.5,  // 20px (1 spacing unit = 8px)
                md: 3.75, // 30px
                lg: 4.25  // 50px
              }
            
         
        }}>
        
            <Typography
            sx={{
                color: '',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800,
                letterSpacing: '0.3px',
                fontSize: {
                xs: 18,  // Extra-small devices (phones)
                sm: 20,  // Small devices (tablets)
                md: 24,  // Medium devices (desktop)
                lg: 28,  // Large screens
                },
                lineHeight: {
                xs: 1.8,
                sm: 2,
                md: 2.5,
                },
            }}
            >
            DISCLAIMER
            </Typography>
            <Typography
            sx={{
                fontFamily: 'Satoshi, sans-serif',
                fontSize: {
                xs: '15px',
                sm: '16px',
                md: '20px',
                },
                lineHeight: 1.5,
                mt: 2,
            }}
          >
            Digital assets and related products offered through Platinx Exchange are unregulated and highly volatile, carrying substantial financial risks. There may be no regulatory recourse in the event of losses incurred from transactions on the platform.
            </Typography>
                <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '15px',
                    sm: '16px',
                    md: '20px',
                    },
                    lineHeight: 1.3,
                    mt: 2,
                }}
                >
                By accessing and utilizing the Platinx Exchange platform or its services, you hereby acknowledge and accept all risks, potential financial losses, and associated costs, including but not limited to total devaluation, forfeiture, or seizure of your digital assets. Should you disagree with any provision of these terms, you are advised to refrain from registering for an account or engaging in any transactions on this platform.
                </Typography>
                <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '15px',
                    sm: '16px',
                    md: '20px',
                    },
                    lineHeight: 1.3,
                    mt: 2,
                }}
                >
                It is imperative that you fully comprehend the risks before engaging in any digital asset-related transactions. You acknowledge and accept that the acquisition, holding, investment, or trading of digital assets (also referred to as cryptocurrencies, virtual digital assets, crypto tokens, etc.) entails a high degree of risk. Digital assets are subject to continuous and unpredictable fluctuations in value and exchange rates, security threats, and regulatory interventions. Consequently, the value of your holdings may fluctuate drastically, potentially resulting in a total loss of your invested capital. Additional risks are delineated in the terms of use; however, they do not encompass all potential contingencies or their applicability to your personal financial circumstances. It is your sole responsibility to assess whether participation in digital asset transactions aligns with your financial position and risk appetite.
                </Typography>
                <Typography
            sx={{
                fontFamily: 'Satoshi, sans-serif',
                fontWeight:500,
                fontSize: {
                xs: '15px',
                sm: '18px',
                md: '24px',
                },
                lineHeight: 1.5,
                my: 2,
                color: 'rgb(255, 107, 0)',
                textDecoration: 'underline',
                textDecorationColor: 'black',
            }}
            >
          Platinx Exchange assumes no liability for any profits, losses, or adverse outcomes incurred through the use of its services.
               </Typography>
                <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '15px', // small screens
                    sm: '16px',
                    md: '20px', // medium and up
                    },
                    lineHeight: 1.3,
                    mt: 2,
                }}
                    >
                    Platinx Exchange may provide educational materials, including blog posts, articles, third-party links, news feeds, tutorials, and videos for informational purposes only. Such content shall not be construed as financial, investment, or trading advice. Platinx Exchange does not endorse or provide recommendations concerning the trading of digital assets, nor does it assess the suitability or appropriateness of investment strategies for users. No oral or written communication from Platinx Exchange, its officers, directors, employees, or agents shall constitute investment, financial, or consulting advice. Any opinions or suggestions provided by its representatives shall be deemed strictly personal and not attributable to Platinx Exchange.
                </Typography>
                <Typography
                    sx={{
                        fontFamily: 'Satoshi, sans-serif',
                        fontSize: {
                        xs: '15px',  // small screens
                        sm: '16px',
                        md: '20px',  // medium and up
                        },
                        lineHeight: 1.3,
                        mt: 2,
                    }}
                    >
                    You hereby acknowledge all trading decisions made while using the platform are undertaken at your sole discretion and risk. Before purchasing, selling, or holding any digital asset, you are strongly encouraged to conduct independent research and consult a professional financial advisor. Platinx Exchange disclaims any liability for decisions made based on information obtained through the platform or its affiliated channels.
                </Typography>
               <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '15px',  // small screens
                    sm: '16px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.3,
                    mt: 2,
                }}
                >
                Hereby it is brought to your notice that Platinx Exchange is not a financial institution, bank, brokerage, trust, hedge fund, intermediary, or investment advisor and does not operate under the regulatory frameworks applicable to such entities. It serves as a technological facilitator providing access to digital asset markets and associated services. Users bear the exclusive responsibility for ensuring that their transactions comply with all applicable legal, regulatory, and tax obligations.
                </Typography>

                <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '15px',  // small screens
                    sm: '16px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.3,
                    mt: 2,
                }}
                >
                Also, Platinx Exchange does not engage in, nor does it authorize, professional referral services (unless expressly agreed upon in writing). If you are referring new users as part of a business or professional activity, you must disclose this relationship to Platinx Exchange, which may be required to deduct additional withholding taxes under applicable laws.
                </Typography>
                
            <Typography
            sx={{
                fontFamily: 'Satoshi, sans-serif',
                fontSize: {
                xs: '15px',  // small screens
                sm: '16px',
                md: '20px',  // medium and up
                },
                lineHeight: 1.3,
                mt: 2,
            }}
            >
            You hereby acknowledge that Platinx Exchange, the platform, and its services may be adversely affected by regulatory changes, legal restrictions, or governmental actions. Platinx Exchange reserves the right to disclose user information to comply with legal, regulatory, or governmental obligations, should it be deemed necessary.
            </Typography>
            <Typography
            sx={{
                fontFamily: 'Satoshi, sans-serif',
                fontSize: {
                xs: '15px',  // small screens
                sm: '16px',
                md: '20px',  // medium and up
                },
                lineHeight: 1.3,
                mt: 2,
            }}
            >
            All transactions executed on the platform are processed automatically in accordance with user instructions and established execution procedures.
            </Typography>
            <Typography
                sx={{
                    fontFamily: 'Satoshi, sans-serif',
                    fontSize: {
                    xs: '15px',  // small screens
                    sm: '16px',
                    md: '20px',  // medium and up
                    },
                    lineHeight: 1.3,
                    mt: 2,
                }}
                >
                This document includes provisions governing the resolution of disputes between you and Platinx Exchange, including a mandatory arbitration agreement. By using the platform, you agree that disputes shall be settled exclusively through arbitration, as specified in the Terms of Use.
            </Typography>
            <Typography
            sx={{
                fontFamily: 'Satoshi, sans-serif',
                fontSize: {
                xs: '15px',  // small screens
                sm: '16px',
                md: '20px',  // medium and up
                },
                lineHeight: 1.3,
                mt: 2,
            }}
            >
            By continuing to use Platinx Exchange's services, you confirm that you understand and accept the terms and risks outlined herein (as specified in the risk disclosure). If you do not agree with any part of this disclaimer, you should immediately cease using the platform and its services.
            </Typography>


        </Box>
      </Box>
  );
};

export default Disclaimer;
